module.exports = __webpack_public_path__ + "img/Credinka.29b46e3c.svg";